<script>
  import { onMount, afterUpdate } from 'svelte'
  import Header from './Header.svelte'
  import TabsReviewsAndQuestions from './TabsReviewsAndQuestions.svelte'
  import KudobuzzLabel from '../../components/KudobuzzLabel.svelte'

  export let contentData
  export let settings

  let summary
  let isFreeUser
  let data
  let loading = true
  let tabSummary
  let summaryType

  const items = [
    {
      label: 'Site reviews',
      show: true
    },
    {
      label: 'Product reviews',
      show: true
    },
    {
      label: 'Questions & Answers',
      show: true
    }
  ]

  let activeTab

  $: if (summary) {
    switch (activeTab) {
      case items[0].label:
        tabSummary = summary.siteReviews
        summaryType = 'reviews'
        break
      case items[1].label:
        tabSummary = summary.productReviews
        summaryType = 'reviews'
        break
      case items[2].label:
        tabSummary = summary.questions
        summaryType = 'questions'
        break
    }
  }

  onMount(async () => {
    summary = Object.keys(contentData).reduce((acc, dataKey) => {
      return { ...acc, [dataKey]: contentData[dataKey].metadata }
    }, {})

    data = Object.keys(contentData).reduce((acc, dataKey) => {
      return { ...acc, [dataKey]: contentData[dataKey].data }
    }, {})

    const planName = settings.plan.name
    isFreeUser = planName === 'coffee' || planName === 'breakfast'
    items[0].label = settings.translations.neptune.site_review_tab_text
    items[1].label = settings.translations.neptune.product_review_tab_text
    items[2].label = settings.translations.neptune.qna_review_tab_text
    const tabsToShow = settings.widget_settings.neptune.tabs_to_show
    items[0].show = tabsToShow.includes('BUSINESS')
    items[1].show = tabsToShow.includes('PRODUCT')
    items[2].show = settings.widget_settings.neptune.show_questions_and_answers
    const activeItem = items.find(item => item.show)
    if (activeItem) {
      activeTab = activeItem.label
    }
    loading = false
  })

  afterUpdate(() => {
    const totalSiteReviews = summary.siteReviews && summary.siteReviews.count
    items[0].count = totalSiteReviews

    const totalReviews = summary.productReviews && summary.productReviews.count
    items[1].count = totalReviews

    const totalQuestions = summary.questions && summary.questions.count
    items[2].count = totalQuestions
  })

  const tabChanged = e => {
    activeTab = e.detail.label
  }
</script>

<style>
  :global(.wrapper__header-2f2oq5) {
    background: #f8f9fa;
    position: relative;
    padding: 15px;
  }

  :global(.header__kb-branding-31L1uJ) {
    position: absolute;
    right: 0;
  }
</style>

{#if !loading}
  <div class="">
    <div class="wrapper__header-2f2oq5">
      <Header summary={tabSummary} {summaryType} {settings} />
    </div>
    <TabsReviewsAndQuestions
      {activeTab}
      {items}
      {summary}
      {data}
      {settings}
      {isFreeUser}
      on:tabChanged={tabChanged} />
  </div>
  {#if isFreeUser}
    <section class="header__kb-branding-31L1uJ">
      <KudobuzzLabel />
    </section>
  {/if}
{/if}
